import { useState } from "react";
import "@/mockups/deepcoast.css";
import { RolloutTab } from "@/components/rollout/RolloutTab";
import { PlanTab } from "@/components/rollout/PlanTab";
import { TenantsTab } from "@/components/rollout/TenantsTab";
import { HealthTab } from "@/components/rollout/HealthTab";
import { ActivityTab, CostsTab } from "@/components/rollout/ActivityCosts";
import CommandCenter from "@/pages/CommandCenter";
import { ActionRequiredTab } from "@/components/rollout/ActionRequiredTab";

const TABS = [["rollout", "Rollout", RolloutTab], ["plan", "Project Plan", PlanTab], ["tenants", "Tenants", TenantsTab],
  ["health", "Health", HealthTab], ["command", "Command Center", () => <CommandCenter embedded />], ["action", "Action Required", ActionRequiredTab], ["activity", "Activity Log", ActivityTab], ["costs", "Costs", CostsTab]];

export default function RolloutCenter() {
  const [tab, setTab] = useState(() => new URLSearchParams(window.location.search).get("tab") || "rollout");
  const Cur = (TABS.find(([k]) => k === tab) || TABS[0])[2];
  return (
    <div className="dc v3" style={{ background: "transparent" }} data-testid="rollout-center">
      <h1 style={{ fontSize: 32, fontWeight: 800, letterSpacing: "-0.02em", margin: "0 0 6px" }}>Rollout Command Center</h1>
      <p className="muted" style={{ fontSize: 14, margin: "0 0 18px" }}>Who is live, what each location costs to run, what broke, and what's left to do.</p>
      <div style={{ display: "flex", gap: 4, borderBottom: "1px solid var(--line)", marginBottom: 18, overflowX: "auto" }}>
        {TABS.map(([k, l]) => (
          <button key={k} onClick={() => { setTab(k); window.history.replaceState(null, "", `?tab=${k}`); }} data-testid={`rollout-tab-${k}`}
            style={{ padding: "10px 14px", fontSize: 14, fontWeight: tab === k ? 700 : 500, color: tab === k ? "var(--accent-ink)" : "var(--muted)", borderBottom: `2px solid ${tab === k ? "var(--accent)" : "transparent"}`, background: "none", whiteSpace: "nowrap" }}>{l}</button>
        ))}
      </div>
      <div className={tab === "command" ? "ops-v3" : undefined}><Cur /></div>
    </div>
  );
}
